<ng-container *ngIf="userService.IsLoggedIn; else loginToAdd">
  <ng-container *ngIf="!this.course.rights.includes('viewcontent')">
    <ng-container *ngIf="(fee$| async) as fee">
      <ng-container *ngIf="fee.prc_price > 0">
        <div class="p-2 d-inline-block mb-2">
          <ng-container *ngIf="!cartService.PendingUpdate">
            <ng-container *ngIf="!cartService.IsItemInCart(course.netforum_course_id)">
              Price: ${{fee.prc_price}} (Free for ABMP {{course.library == 'WMC' ? 'Certified/Associate' : ''}} members)
              <button (click)="AddCourseToCart()">Add to cart</button>
            </ng-container>
            <ng-container *ngIf="cartService.IsItemInCart(course.netforum_course_id)">
              <button (click)="RemoveCourseFromCart()">Remove from cart</button>
              <a class="btn" routerLink="../../cart">View your cart</a>
            </ng-container>
          </ng-container>
          <span *ngIf="cartService.PendingUpdate">
            <app-load-indicator description="update your cart"></app-load-indicator>
          </span>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loginToAdd>
  <div class="p-2 d-inline-block mb-2"><button (click)="ShowLoginModal();">Price: $30 (Free for ABMP {{course.library == 'WMC' ? 'Certified/Associate' : ''}} members)</button></div>
</ng-template>
